import React from "react";
import ParagraphButton, {
	getParagraphButtonProps,
} from "../ParagraphButton/ParagraphButton";
import ParagraphText, {
	getParagraphTextProps,
} from "../ParagraphText/ParagraphText";

export interface ParagraphTextOrButtonProps {
	data: Queries.ParagraphTextOrButtonDataFragment;
	parentTheme?: string;
}
export const ParagraphTextOrButton: React.FC<ParagraphTextOrButtonProps> = (
	{ data: { __typename, ...props } },
	parentTheme,
) => {
	if (__typename === "paragraph__link_button")
		return (
			<ParagraphButton
				{...getParagraphButtonProps(
					props as Queries.ParagraphButtonDataFragment,
					false,
					parentTheme,
				)}
			/>
		);

	return (
		<ParagraphText
			{...getParagraphTextProps(props as Queries.ParagraphTextDataFragment)}
			isSubSection
		/>
	);
};
